import { useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Alert, Button, ButtonGroup } from "reactstrap";
import Loading from "../../components/Loading";
import { getEmpowerMeTasksActive } from "../../graphql/empower-me/EmpowerMeQueries";
import { EmpowerTask } from "../../interfaces/models/EmpowerTask";
import { AccordionSelectorField } from "./Accordion/AccordionSelectorField";
import "./EmpowerMePage.scss";
import { EmpowerMeBundle } from "../../interfaces/models/EmpowerMeBundle";
import { useEmpowerMeBundlesActiveOnly, useEmpowerMeBundlesCategoriesActive } from "../../hooks/useEmpowerMe";
import { EmpowerMeBundleCategory } from "../../interfaces/models/EmpowerMeBundleCategory";
import { useCategoriesEmpowerMe } from "../../hooks/useCategories";
import Category from "../../interfaces/models/Category";
import { getImageSmallUrl } from "../../helper/getImageUrl";

interface TaskSelectionProps {
  select: (task: EmpowerTask) => void;
  currentSelection: EmpowerTask | null;
  selectBundle: (bundle : EmpowerMeBundle) => void;
  currentSelectionBundle: EmpowerMeBundle | null;
  selectedCategory: (string | null);
  setSelectedCategory : (category : string | null) => void;
  selectedSubCategory: (string | null);
  setSelectedSubCategory : (category : string | null) => void;
  selectionType : number,
  setSelectionType : (type : number) => void;
}

interface CategoryRenderInterface {
  id : string;
  image_or_color : string,
  description : string
}

// type CategorisedEmpowerMeTasks = {
//   physicalTasks: EmpowerTask[];
//   nutritionTasks: EmpowerTask[];
//   pyschologicalTasks: EmpowerTask[];
//   mindfulTasks: EmpowerTask[];
// };

let SelectionTypes = {
  NONE: 0,
  SINGLE: 1,
  BUNDLE: 2,
}

export default function EmpowerTaskSelection({
  select,
  currentSelection,
  selectBundle, 
  currentSelectionBundle,
  selectedCategory, 
  setSelectedCategory,
  selectedSubCategory,
  setSelectedSubCategory,
  selectionType, 
  setSelectionType
}: TaskSelectionProps) {
  // TODO: the accordion that contains an initially selected task should be open

  
  let [categories, setCategories] = useState<Category[]>([]);
  let [subCategories, setSubCategories] = useState<Category[]>([]);
  

  // let [empowerMeTasks, setEmpowerMeTasks] =
  //   useState<CategorisedEmpowerMeTasks>({
  //     physicalTasks: [],
  //     nutritionTasks: [],
  //     pyschologicalTasks: [],
  //     mindfulTasks: [],
  //   });
  let [empowerMeTasksSingles, setEmpowerMeTasksSingles] =
    useState<EmpowerTask[]>([]);

  let [empowerMeBundles, setEmpowerMeBundles] = useState<EmpowerMeBundle[]>([]);
  let [empowerMeBundlesCategory, setEmpowerMeBundlesCategory] = useState<EmpowerMeBundleCategory[]>([]);
  let [empowerMeBundlesSubCategory, setEmpowerMeBundlesSubCategory] = useState<EmpowerMeBundleCategory[]>([]);
  let { data : categData, loading : categLoading} = useCategoriesEmpowerMe();
  let { loading: loadingBundles, data: dataBundles } = useEmpowerMeBundlesActiveOnly();
  let { loading: loadingBundlesCategory, data: dataBundlesCategory } = useEmpowerMeBundlesCategoriesActive();

  let SelectCategory = (id : string) => {
    if(selectedCategory === id) {
      setSelectedCategory(null);
    } 
    else {
      setSelectedCategory(id);
    }
  }

  let SelectSubCategory = (id : string) => {
    if(selectedSubCategory === id) {
      setSelectedSubCategory(null);
    } 
    else {
      setSelectedSubCategory(id);
    }
  }

  let MainCategoryRenderer = ({id , image_or_color , description} : CategoryRenderInterface) => {
    return (
      <>
        <Col 
          md={3}
          className={id === selectedCategory ? "bg-lighter text-center" : "text-center"} 
          type="button" 
          onClick={() => SelectCategory(id)}
        >
          <img
            className="mt-4"
              src={getImageSmallUrl(image_or_color)}
              alt={description}
              style={{ 
                height: "80px",
                objectFit: "cover"
              }}
            />
            <div className="font-weight-bold " >{description}</div>
        </Col>
      </>
    )
  }

  let SubCategoryRenderer = ({id, image_or_color, description} : CategoryRenderInterface) => {
    return (
      <Col md={3} >
        <div 
          className="pt-2 text-white py-5 text-center" 
          style={{ backgroundColor: image_or_color, opacity : selectedSubCategory === id ? 1 : 0.8}}
          role="button"
          onClick={() => { SelectSubCategory(id); }}
        >
          <span className="font-weight-bold my-2">{description} </span>
          
        </div>
      </Col>
    )
  }

  // Populate options with empower me tasks
  let { loading, error } = useQuery(getEmpowerMeTasksActive, {
    onCompleted(data) {
      // let categorisedTasks: CategorisedEmpowerMeTasks = {
      //   physicalTasks: [],
      //   nutritionTasks: [],
      //   pyschologicalTasks: [],
      //   mindfulTasks: [],
      // };
      // data?.empower_me_tasks_active.forEach((task, idx) => {
      //   switch (task?.task_category.description) {
      //     case CATEGORY_PHYSICAL:
      //       categorisedTasks.physicalTasks.push(task);
      //       break;
      //     case CATEGORY_NUTRITIONAL:
      //       categorisedTasks.nutritionTasks.push(task);
      //       break;
      //     case CATEGORY_PSYCHOLOGICAL:
      //       categorisedTasks.pyschologicalTasks.push(task);
      //       break;
      //     case CATEGORY_MINDFUL:
      //       categorisedTasks.mindfulTasks.push(task);
      //       break;
      //     default:
      //       break;
      //   }
      // });
      // setEmpowerMeTasks(categorisedTasks);
      if(data) {
        
        setEmpowerMeTasksSingles(data?.empower_me_tasks_active);
      }
    },
    // TODO: display error on failure
    onError(error) {
      console.log("Error occurred: ", error);
    },
  }); 


  useEffect(() => {
    if(dataBundles && dataBundlesCategory) {
      setEmpowerMeBundles(dataBundles.empower_me_bundles_actives);

      const activeBundleCategoriesRaw : EmpowerMeBundleCategory[] = dataBundlesCategory.empower_me_bundle_categories_actives; 
      let main : EmpowerMeBundleCategory[] = [];
      let sub : EmpowerMeBundleCategory[] = [];
      for(let x = 0; x < activeBundleCategoriesRaw.length; x++) {
        const getActiveBundleCategoriesRaw = activeBundleCategoriesRaw[x];

        if(getActiveBundleCategoriesRaw.level === 1) {
          main.push(getActiveBundleCategoriesRaw);
        }
        else {
          sub.push(getActiveBundleCategoriesRaw);
        }
      }
      setEmpowerMeBundlesCategory(main);
      setEmpowerMeBundlesSubCategory(sub);
    }
  },[dataBundles, dataBundlesCategory]);
  
  useEffect(() => {
    if(categData) {
        let categRaw : Category[] = categData.categories_empower_me; 
        let mainCategs = [];
        let subCategs = [];
        for(let x = 0; x < categRaw.length; x++) {
          let categ = categRaw[x];

          if(categ.level === 2) {
            mainCategs.push(categ);
          }
          else {
            subCategs.push(categ);
          }
        }
        setCategories(mainCategs);
        setSubCategories(subCategs);
        setSelectedCategory(mainCategs[0]._id);
    }
  }, [categData, setSelectedCategory]);


  if (loading || loadingBundles || loadingBundlesCategory) return <Loading />;
  if (error) {
    return (
      <Alert color="danger">
        Sorry! Something went wrong while retrieving the empower me tasks -
        Please try again later or contact a System Administrator.
      </Alert>
    );
  }


  return (
    <div>
      {/* TODO: add prop `defaultActivityKey="eventKey" to the Accordion component to determine which accordion item should be open by default - use this to open the accordion item containing the pre-selected task (during edit)_  */}
      <div className="d-flex justify-content-center align-items-center mb-3">
        <ButtonGroup style={{ display: 'flex', width: '50%' }}>
          <Button style={{ flex: 1 }} 
          color={selectionType === SelectionTypes.SINGLE ? "primary" : "secondary"} 
          onClick={() => { setSelectionType(SelectionTypes.SINGLE); selectBundle(null); }} >
            Single
          </Button>
          <Button style={{ flex: 1 }} 
          color={selectionType === SelectionTypes.BUNDLE ? "primary" : "secondary"} 
          onClick={() => { setSelectionType(SelectionTypes.BUNDLE); select(null); }}>
            Bundle
          </Button>
        </ButtonGroup>
      </div>
      
      {
        selectionType === SelectionTypes.SINGLE ?
        <>
          {
            categLoading &&
            <Loading />
          }
          <Row className="m-0 pb-3">
            {
              categories.map((item, index) => (
                <MainCategoryRenderer 
                  key={index}
                  id={item._id}
                  image_or_color={item.image}
                  description={item.description}
                />
              ))
            }
          </Row>
          
          <Row className="m-0" >
            {
                subCategories.filter(u => u.parent_id === selectedCategory).map((sub, subIndex) => {

                  return(
                    <SubCategoryRenderer 
                      key={subIndex}
                      id={sub._id}
                      image_or_color={sub.color}
                      description={sub.description}
                    />
                  )
                })
              }
          </Row>
          <div>
            <TaskSelectAccordionOptionsList
              currentSelection={currentSelection}
              onSelect={select}
              options={empowerMeTasksSingles.filter(u => u.task_category._id === selectedSubCategory)}
            /> 
          </div>
        
        </>
        // <Accordion flush alwaysOpen>
        //   <Accordion.Item eventKey={CATEGORY_PHYSICAL}>
        //     <AccordionHeader
        //       title={CATEGORY_PHYSICAL}
        //       eventKey={CATEGORY_PHYSICAL}
        //     />
        //     <Accordion.Body className="pb-2">
        //       <TaskSelectAccordionOptionsList
        //         currentSelection={currentSelection}
        //         onSelect={select}
        //         options={empowerMeTasks.physicalTasks}
        //       />
        //     </Accordion.Body>
        //   </Accordion.Item>
        //   <Accordion.Item eventKey={CATEGORY_NUTRITIONAL}>
        //     <AccordionHeader
        //       title={CATEGORY_NUTRITIONAL}
        //       eventKey={CATEGORY_NUTRITIONAL}
        //     />
        //     <Accordion.Body className="pb-2">
        //       <TaskSelectAccordionOptionsList
        //         currentSelection={currentSelection}
        //         onSelect={select}
        //         options={empowerMeTasks.nutritionTasks}
        //       />
        //     </Accordion.Body>
        //   </Accordion.Item>
        //   <Accordion.Item eventKey={CATEGORY_PSYCHOLOGICAL}>
        //     <AccordionHeader
        //       title={CATEGORY_PSYCHOLOGICAL}
        //       eventKey={CATEGORY_PSYCHOLOGICAL}
        //     />
        //     <Accordion.Body className="pb-2">
        //       <TaskSelectAccordionOptionsList
        //         currentSelection={currentSelection}
        //         onSelect={select}
        //         options={empowerMeTasks.pyschologicalTasks}
        //       />
        //     </Accordion.Body>
        //   </Accordion.Item>
        //   <Accordion.Item eventKey={CATEGORY_MINDFUL}>
        //     <AccordionHeader
        //       title={CATEGORY_MINDFUL}
        //       eventKey={CATEGORY_MINDFUL}
        //     />
        //     <Accordion.Body className="pb-2">
        //       <TaskSelectAccordionOptionsList
        //         currentSelection={currentSelection}
        //         onSelect={select}
        //         options={empowerMeTasks.mindfulTasks}
        //       />
        //     </Accordion.Body>
        //   </Accordion.Item>
        // </Accordion>
        :
        selectionType === SelectionTypes.BUNDLE ?
        <>
          
          <Row className="m-0 p-0">
            {
              empowerMeBundlesCategory.map((category, index) => (

                <MainCategoryRenderer
                  id={category._id}
                  image_or_color={category.image_id}
                  description={category.name}
                /> 
                // <Col key={index} xs={12} md={4}>
                //   <Card key={index} className="mb-3">
                //     <CardHeader className="pb-2 pt-2 text-center">
                      
                //       <h3 className="text-center ">{category.name}</h3>
                //     </CardHeader>
                //     <CardBody className="pt-2">
                //       <div>
                //         <small className="">
                //           {category.description}
                //         </small>
                //         <div>
                //           <ul className="list-group list-group-flush">
                //             {
                //               empowerMeBundles.filter((bundle) => bundle.bundle_category_id === category._id).map((bundle, index) => (
                //                 <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                //                   <div className="d-flex flex-column">
                //                     <small style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}><b>{bundle.name}</b> </small>
                //                     <small style={{ wordBreak: 'break-word', whiteSpace: 'normal' }} >{bundle.description} </small>
                //                   </div>
                //                   <div>
                //                     <Button size="sm" color={currentSelectionBundle?._id === bundle._id ? "primary" : "secondary"} onClick={() => { selectBundle(bundle) }}>
                //                       Select
                //                     </Button>
                //                   </div>
                //                 </li>
                //               ))
                //             }
                //           </ul>
                //         </div>
                //       </div>
                //     </CardBody>
                //   </Card>
                // </Col>
              ))
            }
          </Row>
          <Row className="m-0" >
            {
                empowerMeBundlesSubCategory.filter(u => u.parent_id === selectedCategory).map((sub, subIndex) => {

                  return(
                    <SubCategoryRenderer 
                      key={subIndex}
                      id={sub._id}
                      image_or_color={sub.color || "#000000"}
                      description={sub.description}
                    />
                  )
                })
              }
          </Row>
          <Row className="m-0">
            {
              empowerMeBundles.filter((bundle) => bundle.bundle_category_id === selectedSubCategory).map((bundle, index) => (
                <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                  <div className="d-flex flex-column">
                    <small style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}><b>{bundle.name}</b> </small>
                    <small style={{ wordBreak: 'break-word', whiteSpace: 'normal' }} >{bundle.description} </small>
                  </div>
                  <div>
                    <Button size="sm" color={currentSelectionBundle?._id === bundle._id ? "primary" : "secondary"} onClick={() => { selectBundle(bundle) }}>
                      Select
                    </Button>
                  </div>
                </li>
              ))
            }
          </Row>
        </>
        :
        <></>
      }
    </div>
  );
}

interface OptionsProps {
  options: EmpowerTask[];
  onSelect: (task: EmpowerTask) => void;
  currentSelection: EmpowerTask | null;
}
function TaskSelectAccordionOptionsList(props: OptionsProps) {
  return (
    <Container fluid>
      <Row className="">
        {props.options.map((empowerTask, idx) => {
          return (
            <Col key={idx} xs={12} md={6} xl={4} className="pt-1">
              <AccordionSelectorField
                key={idx}
                empowerTask={empowerTask}
                isSelected={props.currentSelection?._id === empowerTask._id}
                onSelect={props.onSelect}
                name={"taskId"}
              />
            </Col>
          );
        })}

      </Row>
    </Container>
  );
}
